import { useState, Fragment } from 'react';
import { Button, Skeleton, Box } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useCasesForCurrentCustomer, mutateCurrentUserCase } from '../../api/swrcurrentusercontext.js';
import { AutocompleteElement } from 'react-hook-form-mui';
import { useForm } from 'react-hook-form-mui';
import { FormContainer } from 'react-hook-form-mui';
import UserProfileContext from '../../context/userprofilecontext.js';
import { useContext } from 'react';


function getCaseValue(caseID, caseName) {
  return { id: caseID, label: caseName }
}

function getCaseValues(data, currentCaseID) {
  const id_field = "caseID";
  const label_field = "caseName";

  let filteredData = data.filter((record) => record.status === 'ACTIVE')

  let values = filteredData.map((record) => {
    return getCaseValue(record[id_field], record[label_field]);
  });

  return { values: values };
}

export default function SelectCurrentCaseDialog(props) {

  const parentOnSubmit = props.onSubmit ? props.onSubmit : () => { };
  const parentOnCancel = props.onCancel ? props.onCancel : () => { };
  const title = props.title ? props.title : "Select Current Case";

  const userProfileContext = useContext(UserProfileContext);
  const userCases = useCasesForCurrentCustomer();

  const currentCaseID = userProfileContext.userProfile?.currentCase?.caseID || null;
  const currentCaseName = userProfileContext.userProfile?.currentCase?.caseName || '';

  const defaultValues = currentCaseID
    ? { "current_case": getCaseValue(currentCaseID, currentCaseName) }
    : { "current_case": null };

  const [values, setValues] = useState(defaultValues);

  const formContext = useForm({
    defaultValues: defaultValues, values
  });

  const { handleSubmit, setValue } = formContext;

  const handleCancel = () => {
    parentOnCancel();
  };

  const onSubmit = (data) => {
    const newCaseID = data.current_case.id;
    setValues(data);
    mutateCurrentUserCase(newCaseID);
    parentOnSubmit(data);
  };

  if (userCases.isLoading || userCases.error || !userCases.data || userCases.data.length === 0) {
    return (
      <Fragment>
        <Dialog open={props.open} onClose={handleCancel}>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Skeleton variant="rectangular" sx={{ minWidth: 500, minHeight: 300 }} />
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  }

  let options = [];
  if (userCases.data.length > 0) {
    let cases = getCaseValues(userCases.data, currentCaseID);
    options = cases.values;
  }

  return (
    <Fragment>
      <Dialog open={props.open} onClose={handleCancel}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent sx={{ minWidth: 500, minHeight: 300 }}>
          <FormContainer values={values} defaultValues={defaultValues} formContext={formContext} handleSubmit={handleSubmit}>
            <Box sx={{ pt: 1 }}>
              <AutocompleteElement name="current_case" options={options} setValue={setValue} label="Current Case" required />
            </Box>
            <Button
              style={{ margin: "10px 0px", maxWidth: "75px" }}
              onClick={handleSubmit(onSubmit)} variant={"contained"}>
              Save
            </Button>
          </FormContainer>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}